import { useRouter } from 'found';
import React from 'react';
import CommunityCard from 'containers/cards/Community';

const CommunityList = ({ data, viewer, handleLike }) => {
  const { router } = useRouter();
  return (
    Array.isArray(data?.discoverSponsors?.data)
    && data?.discoverSponsors?.data?.map((list, index) => (
      <CommunityCard
        community={list}
        compact
        key={index}
        onClick={() => router.push(`/communities/${encodeURIComponent(list.slug)}`)}
        viewer={viewer}
        handleLike={handleLike}
      />
    ))
  );
};

export default CommunityList;
